import { Injectable } from '@angular/core';
import posthog, { PostHog } from 'posthog-js';

import { WindowRefService } from '@main-client/src/app/window-ref.service';

import { environment } from '@libs/src/environments/environment';
import { Account } from '@libs/src/models/account.model';
import { isTenThousandCoffeesAdmin } from '@main-client/src/app/user/user.helpers';

@Injectable({ providedIn: 'root' })
export class PostHogService {
  readonly postHogApiHost = 'https://eu.posthog.com';
  readonly productionDomain = 'tenthousandcoffees.com';
  postHogInstance: PostHog;

  constructor(private readonly windowService: WindowRefService) {}

  init(user: Account) {
    posthog.init(environment.postHog.apiKey, {
      api_host: this.postHogApiHost,
      disable_session_recording: true,
      loaded: (instance) => {
        this.postHogInstance = instance;
        this.postHogInstance.identify(user._id);
        if (
          user.opted_for_screen_recording ||
          (this.windowService.nativeWindow.location.host.includes(
            this.productionDomain,
          ) &&
            isTenThousandCoffeesAdmin(user))
        ) {
          this.startSessionRecording();
        }
      },
    });
  }

  startSessionRecording() {
    this.postHogInstance?.startSessionRecording();
  }

  isFeatureEnabled(featureName: string) {
    return this.postHogInstance?.isFeatureEnabled(featureName);
  }
}
